import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API,
  withCredentials: true,
});

// Request interceptor: attach access token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers["Authorization"] = token;
  return config;
});

// Response interceptor: handle 401 / refresh token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loops
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Call refresh endpoint (refresh token is in HTTP-only cookie)
        const res = await axios.post(
          `${process.env.REACT_APP_API}/auths/refresh`,
          {},
          { withCredentials: true }, // important to send cookie
        );

        const { accessToken } = res.data;
        localStorage.setItem("token", accessToken);

        // Retry original request with new token
        originalRequest.headers["Authorization"] = accessToken;
        return axios(originalRequest);
      } catch (refreshError) {
        // Refresh failed → log out
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
